import dynamic from "next/dynamic";
import { JourneyMetaItem } from "@components/car/journey/types.d";
// import metaDatav1 from "./metaDataOld";

const CalenderIcon = dynamic<any>(
  () => import("@public/images/calender-icon.svg"),
  {
    ssr: true
  }
);
const CarIcon = dynamic<any>(() => import("@public/images/car-black.svg"), {
  ssr: true
});
const DocumentIcon = dynamic<any>(
  () => import("@public/images/document-icon.svg"),
  {
    ssr: true
  }
);
const LocationIcon = dynamic<any>(
  () => import("@public/images/location-icon.svg"),
  {
    ssr: true
  }
);

const CarIconV2 = dynamic<any>(() => import("@public/images/car-icon-v2.svg"), {
  ssr: true
});

const PincodeIconV2 = dynamic<any>(
  () => import("@public/images/pincode-v2.svg"),
  {
    ssr: true
  }
);

const PEIconV2 = dynamic<any>(
  () => import("@public/images/policy-expiry-v2.svg"),
  {
    ssr: true
  }
);

const NCBIconV2 = dynamic<any>(() => import("@public/images/ncb-gift-v2.svg"), {
  ssr: true
});

export const currentYear = new Date().getFullYear();

export const registrationYearLimit = 15;

export const bikeRegistrationYearLimit = 15;

export const startYear = currentYear - registrationYearLimit;

export const bikeStartYear = currentYear - bikeRegistrationYearLimit;
export const registrationMaskedValue = currentYear - 21 - 1;
export const maskedYearStart = currentYear - 15;
type MetaData = {
  [key: string]: JourneyMetaItem;
};

export const ncbDetailMap = [
  {
    claimFreeYears: 1,
    discount: "0%"
  },
  {
    claimFreeYears: 2,
    discount: "20%"
  },
  {
    claimFreeYears: 3,
    discount: "25%"
  },
  {
    claimFreeYears: 4,
    discount: "35%"
  },
  {
    claimFreeYears: 5,
    discount: "45%"
  }
];

export const addDaysToCurrentDate = days => {
  return new Date(new Date().getTime() + days * 24 * 60 * 60 * 1000);
};

export const ncbMapping = [
  {
    text: "No claims last year",
    discount: "0%",
    year: 0
  },
  {
    text: "No claims in the last 2 years",
    discount: "20%",
    year: 2
  },
  {
    text: "No claims in the last 3 years",
    discount: "25%",
    year: 3
  },
  {
    text: "No claims in the last 4 years",
    discount: "35%",
    year: 4
  },
  {
    text: "No claims in the last 5 years",
    discount: "45%",
    year: 5
  },
  {
    text: "No claims in the last 6 years",
    discount: "50%",
    year: 6
  }
];

export const ncbMap = {
  6: "50%",
  5: "50%",
  4: "45%",
  3: "35%",
  2: "25%",
  1: "20%",
  0: "0%"
};

export const fieldToIconMetaV2 = item => {
  switch (item) {
    case "carNumber":
      return CarIconV2;
    case "mmv":
      return null;
    case "pinCode":
      return PincodeIconV2;
    case "registrationMonth":
      return null;
    case "expiry":
      return PEIconV2;
    case "ncb":
      return NCBIconV2;
    default:
      return null;
  }
};

export const metaData: MetaData = {
  carType: {
    key: "type",
    title: "Type",
    url: "vehicle-details",
    icon: CarIcon,
    options: [
      {
        name: "Private Car",
        value: "0"
      },
      {
        name: `Commercial Car`,
        value: "1"
      }
    ],
    analyticsScreen: "commercial_vehicle_capture_screen"
  },
  isCorporate: {
    question: "Who is the insurance for?",
    key: "is_corporate",
    title: "Commercial Type",
    url: "vehicle-details",
    icon: CarIcon,
    options: [
      {
        name: "Individual",
        value: false
      },
      {
        name: "Company",
        value: true,
        disabled: false
      }
    ],
    analyticsScreen: "commercial_vehicle_capture_screen"
  },
  previousPolicyType: {
    question: "What is your previous policy type?",
    key: "previous_policy_type",
    title: "Previous Policy Type",
    url: "previous-policy-type",
    icon: CarIcon,
    options: [
      {
        name: "Comprehensive",
        value: "COMPREHENSIVE"
      },
      {
        name: "Third-Party",
        value: "THIRD_PARTY"
      }
    ],
    analyticsScreen: "previous_policy_type_screen"
  },
  pinCode: {
    question: "Enter current address pincode ",
    description: "Enter your pin code",
    key: "pincode",
    title: "Pin Code",
    url: "user-details",
    icon: LocationIcon,
    analyticsScreen: "pincode_capture_screen"
  },
  dob: {
    question: "What's your date of birth?",
    description: "Type your date of birth here",
    key: "date_of_birth",
    title: "Date Of Birth",
    url: "date-of-birth",
    icon: CalenderIcon,
    analyticsScreen: "dob_capture_screen"
  },
  hereIsYourCar: {
    question: "Here’s your car",
    key: "phone",
    title: "Mobile Number",
    url: "your-car",
    icon: CarIcon,
    analyticsScreen: "mmv_confirmation_screen"
  },
  carNumber: {
    question: "Enter your car number",
    description: "This makes your purchase twice as fast",
    key: "registration_number",
    title: "Car Number",
    url: "car-number",
    icon: CarIcon,
    analyticsScreen: "registration_number_screen"
  },
  lastPolicyClaim: {
    question: "Did you file a claim in your last policy period?",
    subtext: "You can get amazing discounts basis your claim history.",
    key: "previous_policy_claim_answer",
    title: "Last Policy Claim",
    icon: CalenderIcon,
    options: [
      {
        name: "Yes",
        value: "claimed"
      },
      {
        name: "No",
        value: "not_claimed"
      },
      {
        name: "I have never made a claim",
        value: "never_claimed"
      }
    ],
    url: "last-policy-claim",
    analyticsScreen: "last_claim_year_screen"
  },
  ncb: {
    question: "What is your current No Claims Bonus (NCB)?",
    description: "",
    icon: CalenderIcon,
    subtext:
      "NCB is based on your claim history. If you did not claim in last 5 policy periods your maximum NCB would be 50% and for 1 year it would be 20%",
    key: "",
    options: [
      {
        name: "50%",
        value: "50"
      },
      {
        name: "45%",
        value: "45"
      },
      {
        name: "35%",
        value: "35"
      },
      {
        name: "25%",
        value: "25"
      },
      {
        name: "20%",
        value: "20"
      },
      {
        name: "0%",
        value: "0"
      },
      {
        name: "I don't remember",
        value: "0"
      }
    ],
    url: "last-policy-claim",
    analyticsScreen: "last_claim_year_screen"
  },
  expiry: {
    question: "Has your current policy expired?",
    key: "previous_policy_expired",
    title: "Current Policy",
    options: [
      {
        name: "Policy not Expired",
        value: false,
        buttonId: "notExpired",
        analyticsKey: "previous_policy_expired",
        analyticsValue: "No, it hasn't expired."
      },
      {
        name: "Policy Expired",
        value: true,
        buttonId: "expired",
        analyticsKey: "previous_policy_expired",
        analyticsValue: "Yes, it has expired."
      }
    ],
    icon: DocumentIcon,
    url: "expiry",
    analyticsScreen: "previous_policy_expiry_screen"
  },
  expiryDates: {
    question: "Enter your Third Party and Own Damage expiry dates",
    description: "Refer your current policy document",
    key: "policy_expiry_dates",
    title: "Current Policy",
    options: [
      {
        name: "TP Plan Expiry Date",
        type: "tpExpiredDate",
        buttonId: "notExpired",
        icon: CalenderIcon,
        analyticsKey: "previous_policy_expired",
        analyticsValue: "No, it hasn't expired."
      },
      {
        name: "OD Plan Expiry Date",
        type: "odExpiredDate",
        buttonId: "expired",
        icon: CalenderIcon,
        analyticsKey: "previous_policy_expired",
        analyticsValue: "Yes, it has expired."
      }
    ],
    icon: DocumentIcon,
    url: "expiry-dates",
    analyticsScreen: "previous_policy_expiry_screen"
  },
  own_damage_pped: {
    title: "Own Damage PPED",
    key: "own_damage_pped",
    icon: DocumentIcon,
    url: "expiry-dates",
    analyticsScreen: "previous_policy_expiry_screen"
  },
  third_party_pped: {
    title: "Own Damage PPED",
    key: "third_party_pped",
    icon: DocumentIcon,
    url: "expiry-dates",
    analyticsScreen: "previous_policy_expiry_screen"
  },
  policyNotExpired: {
    question: "When is your policy expiring?",
    key: "previous_policy_status",
    title: "Policy Expiry Date",
    options: [
      {
        name: "Today or Tomorrow",
        value: "+0-1",
        analyticsKey: "previous_policy_expiry_date",
        analyticsValue: "Today or Tomorrow"
      },
      {
        name: "Within the next 7 days",
        value: "+2-7",
        analyticsKey: "previous_policy_expiry_date",
        analyticsValue: "Within the next 7 days"
      },
      {
        name: "Within the next 30 days",
        value: "+8-30",
        analyticsKey: "previous_policy_expiry_date",
        analyticsValue: "Within the next 30 days"
      },
      {
        name: "After 30 days",
        value: "+30-",
        analyticsKey: "previous_policy_expiry_date",
        analyticsValue: "After 30 days"
      }
    ],
    icon: DocumentIcon,
    url: "policy-status",
    analyticsScreen: "previous_policy_expiry_screen"
  },
  policyStatus: {
    question: "When did your policy expire?",
    key: "previous_policy_status",
    title: "Policy Expired",
    options: [
      {
        name: "Within 10 days",
        value: "0-10",
        analyticsKey: "previous_policy_status",
        analyticsValue: "Less than 10 days ago"
      },
      {
        name: "10 to 90 days",
        value: "11-90",
        analyticsKey: "previous_policy_status",
        analyticsValue: "Between 10 and 90 days"
      },
      {
        name: "More than 90 days",
        value: "90-",
        analyticsKey: "previous_policy_status",
        analyticsValue: "More than 90 days ago"
      }
    ],
    icon: DocumentIcon,
    url: "policy-status",
    analyticsScreen: "previous_policy_expiry_screen"
  },
  registrationYear: {
    question: "Select car registration year",
    key: "registration_year",
    title: "Purchase Year",
    options: [
      {
        name: currentYear,
        value: currentYear,
        className: "registrationYear"
      },
      {
        name: currentYear - 1,
        value: currentYear - 1,
        className: "registrationYear"
      },
      {
        name: currentYear - 2,
        value: currentYear - 2,
        className: "registrationYear"
      },
      {
        name: currentYear - 3,
        value: currentYear - 3,
        className: "registrationYear"
      },
      {
        name: currentYear - 4,
        value: currentYear - 4,
        className: "registrationYear"
      },
      {
        name: currentYear - 5,
        value: currentYear - 5,
        className: "registrationYear"
      },
      {
        name: currentYear - 6,
        value: currentYear - 6,
        className: "registrationYear"
      },
      {
        name: currentYear - 7,
        value: currentYear - 7,
        className: "registrationYear"
      },
      {
        name: currentYear - 8,
        value: currentYear - 8,
        className: "registrationYear"
      },
      {
        name: currentYear - 9,
        value: currentYear - 9,
        className: "registrationYear"
      },
      {
        name: currentYear - 10,
        value: currentYear - 10,
        className: "registrationYear"
      },
      {
        name: currentYear - 11,
        value: currentYear - 11,
        className: "registrationYear"
      },
      {
        name: currentYear - 12,
        value: currentYear - 12,
        className: "registrationYear"
      },
      {
        name: currentYear - 13,
        value: currentYear - 13,
        className: "registrationYear"
      },
      {
        name: currentYear - 14,
        value: currentYear - 14,
        className: "registrationYear"
      },
      {
        name: currentYear - 15,
        value: currentYear - 15,
        className: "registrationYear"
      },
      {
        name: `Before ${currentYear - 15}`,
        value: "0",
        is_registration_year_masked: true,
        maskedValue: registrationMaskedValue,
        className: "registrationYear"
      }
    ],
    icon: CalenderIcon,
    url: "vehicle-details",
    analyticsScreen: "registration_year_screen"
  },
  registrationMonth: {
    question: "Select car registration month",
    key: "registration_month",
    title: "Purchase Month",
    options: [
      {
        name: "Jan",
        displayName: "January",
        value: 1
      },
      {
        name: "Feb",
        displayName: "February",
        value: 2
      },
      {
        name: "Mar",
        displayName: "March",
        value: 3
      },
      {
        name: "Apr",
        displayName: "April",
        value: 4
      },
      {
        name: "May",
        displayName: "May",
        value: 5
      },
      {
        name: "Jun",
        displayName: "June",
        value: 6
      },
      {
        name: "Jul",
        displayName: "July",
        value: 7
      },
      {
        name: "Aug",
        displayName: "August",
        value: 8
      },
      {
        name: "Sep",
        displayName: "September",
        value: 9
      },
      {
        name: "Oct",
        displayName: "October",
        value: 10
      },
      {
        name: "Nov",
        displayName: "November",
        value: 11
      },
      {
        name: "Dec",
        displayName: "December",
        value: 12
      }
    ],
    icon: CalenderIcon,
    url: "vehicle-details",
    analyticsScreen: "registration_month_screen"
  },
  rto: {
    question: "Where will you register your car?",
    key: "rto_ekey",
    title: "RTO",
    url: "rto",
    icon: LocationIcon,
    analyticsScreen: "rto_screen"
  },
  tentativePurchaseDate: {
    question: "When are you planning to buy your car?",
    key: "tentative_purchase_date",
    title: "Tentative Purchase Date",
    options: [
      {
        name: "Today or tomorrow",
        value: "Today or tomorrow",
        analyticsKey: "carPurchaseAnswerSelected",
        analyticsValue: addDaysToCurrentDate(2)?.toString()
      },
      {
        name: "In the next 1 week",
        value: "In the next 1 week",
        analyticsKey: "carPurchaseAnswerSelected",
        analyticsValue: addDaysToCurrentDate(7)?.toString()
      },
      {
        name: "In the next 2 weeks",
        value: "In the next 2 weeks",
        analyticsKey: "carPurchaseAnswerSelected",
        analyticsValue: addDaysToCurrentDate(14)?.toString()
      },
      {
        name: "I am not sure yet",
        value: "I am not sure yet",
        analyticsKey: "carPurchaseAnswerSelected",
        analyticsValue: addDaysToCurrentDate(10)?.toString()
      }
    ],
    url: "tentative-purchase-date",
    icon: CarIcon,
    analyticsScreen: "car_purchase_question_screen"
  },
  mmv: {
    question: "Choose your car",
    newCarQuestion: "Which car are you planning to buy?",
    key: "variant_ekey",
    title: "MMV",
    url: "vehicle-details",
    icon: CarIcon,
    analyticsScreen: "select_make_model_variant_screen"
  },
  fuelType: {
    key: "fuel_type",
    title: "Fuel Type",
    url: "vehicle-details",
    icon: CarIcon
  },
  planName: {
    key: "plan_name",
    title: "Plan Name",
    icon: DocumentIcon,
    url: "nsr"
  },
  vehicleDetails: {
    question: "Enter car details",
    key: "",
    title: "Here's your car",
    url: "vehicle-details",
    analyticsScreen: "vehicle-details"
  },
  userDetails: {
    question: "Enter details",
    key: "",
    title: "A little bit more about you.",
    url: "user-details",
    analyticsScreen: "user-details"
  }
};

export const urlJourneyConfigMapping = {
  "car-type": "carType",
  "commercial-type": "isCorporate",
  "previous-policy-type": "previousPolicyType",
  pincode: "pinCode",
  "date-of-birth": "dob",
  mmv: "mmv",
  "vehicle-details": "vehicleDetails",
  "user-details": "userDetails",
  "registration-month": "registrationMonth",
  rto: "rto",
  "policy-status": "policyStatus",
  expiry: "expiry",
  "last-policy-claim": "lastPolicyClaim",
  "car-number": "carNumber",
  "your-car": "hereIsYourCar",
  "registration-year": "registrationYear",
  policynotexpired: "policyNotExpired",
  "expiry-dates": "expiryDates",
  "tentative-purchase-date": "tentativePurchaseDate"
};

export const optionalFieldsForNavigation = ["externalCNGKit"];

export const allFuelTypes = {
  petrol: "Petrol",
  diesel: "Diesel",
  internal_lpg_cng: "CNG", // eslint-disable-line
  electric: "Electric"
};

export const transmissionTypes = {
  MANUAL: "Manual",
  AUTOMATIC: "Automatic"
};

export const checkoutProgress = {
  details: 1,
  "verify-otp": 2,
  review: 3
};

export const piCheckoutProgress = {
  details: 1,
  "verify-otp": 1,
  review: 2
};
export const gpayBikeCheckoutProgress = {
  details: 1,
  review: 2
};

export const journeyProduct = [
  { journey: "newCar", url: "/new-car/" },
  { journey: "freshCar", url: "/car-journey/" },
  { journey: "renewCar", url: "/renew-policy" },
  { journey: "freshBike", url: "/bike-journey/" }
];

// Switch default export between metadatav1 and metadata for switching between prequote p1 and old prequote
export default metaData;
